/*
* Organized by primary symptom
* Related symptoms e.g. wet cough -> dry cough with links
* Table with treatments:
  * quick explanation
  * efficacy
  * cost
  * forms / list of delivery mechanisms
  * easy vs difficult language toggle?
  * link to guidelines

*/


const conditionData = [
  {
    name: "Pain Relief",
    id: 1,
    description: "Over-the-counter medicine for pain in a specific area (localized) or in your whole body",
    links: [
      {
        url: "https://www.webmd.com/pain-management/default.htm",
        text: "WebMD"
      }
    ],
    relatedIds: [],
    treatments: [
      {
        text: "Ibuprofen",
        indications: ["Headache", "Total Body Pain", "Fever", "Inflammation"],
        fda_approved: true,
        cost_generic: "$1-5 per 100 tablets",
        formulations: ["pill", "liquid"],
        strength_names: ["Normal"],
        strengths: ["200 mg tablets", "100 mg / 5mL Liquid"],
        side_effects: ["Allergic reaction (hives)", "Stomach bleeding/ulcer"],
        directions: "Take 1 to 2 tablets (200 mg each) once every 4 to 6 hours as needed by mouth, OR take 10-20 mL by mouth every 6-8 hours as needed by mouth, DO NOT EXCEED 3200 MG DAILY",
        counsel_points: "Take with milk or food to reduce likelihood of side effects."
      },
      {
        text: "Acetaminophen",
        indications: ["Headache", "Total Body Pain", "Fever"],
        fda_approved: true,
        cost_generic: "$1-5 per 100 tablets",
        formulations: ["pill", "liquid"],
        strength_names: ["Normal, Extra, Arthritis"],
        strengths: ["325 mg", "500 mg (Extra Strength)", "650 mg (Arthritis Strength)"],
        side_effects: ["Liver damage", "Drinking alcohol"],
        directions: "Take 1 to 2 tablets (325 mg each) once every 8 hours as needed by mouth, OR take 20 mL by mouth every 4 hours as needed by mouth, DO NOT EXCEED 3000 MG DAILY",
        counsel_points: "Do not drink alcohol while taking this medication, keep track of how much acetaminophen intake."
      },
      {
        text: "Naproxen",
        indications: ["Headache", "Total Body Pain", "Fever", "Inflammation"],
        fda_approved: true,
        cost_generic: "$10-25 per 100 tablets",
        formulations: ["pill", "liquid"],
        strength_names: ["Normal, Extra"],
        strengths: ["200 mg tablets", "100 mg / 5mL Liquid"],
        side_effects: ["Allergic reaction (hives)", "Stomach bleeding/ulcer"],
        directions: "Take one tablet, caplet, gelcap or liquid gel every 8 to 12 hours while symptoms last. DO NOT EXCEED 1000 MG DAILY.",
        counsel_points: "Take with milk or food to reduce likelihood of side effects."
      },
      {
        text: "Diclofenac",
        indications: ["Joint Pain", "Localized Inflammation"],
        fda_approved: true,
        cost_generic: "$10-25 per 40 grams",
        formulations: ["gel"],
        strength_names: ["Normal"],
        strengths: ["200 mg tablets", "100 mg / 5mL Liquid"],
        side_effects: ["Allergic reaction (hives)", "Skin irritation", "Burning/numbness/tingle"],
        directions: "Adults—Apply 2 grams (g) to the affected skin areas four times a day (a total of 8 g each day). DO NOT EXCEED 32 GRAMS IN A SINGLE DAY.",
        counsel_points: "Apply a thin layer to the affected area, do not apply to open wounds, do not consume by mouth."
      },
      {
        text: "Aspirin",
        indications: ["Headache", "Total Body Pain", "Fever", "Inflammation"],
        fda_approved: true,
        cost_generic: "$1-5 per 100 tablets",
        formulations: ["pill"],
        strength_names: ["Preventative", "Normal"],
        strengths: ["200 mg tablets", "100 mg / 5mL Liquid"],
        side_effects: ["Allergic reaction (hives)", "Stomach bleeding/ulcer"],
        directions: "Take one tablet every 4 hours as needed to manage symptoms. Do not exceed 3 grams in a single day.",
        counsel_points: "Take with milk or food to reduce likelihood of side effects."
      }
    ]
  },
  {
    name: "Allergies",
    id: 2
  }
];

export default conditionData;